import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=1334eb20&scoped=true&"
import script from "./BaseModal.vue?vue&type=script&lang=js&"
export * from "./BaseModal.vue?vue&type=script&lang=js&"
import style0 from "./BaseModal.vue?vue&type=style&index=0&id=1334eb20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1334eb20",
  null
  
)

export default component.exports